import { List } from 'antd';
import React from 'react';

import { CommentType } from '../../types';
import CommentItem from '../CommentItem/CommentItem';

export default function Comments({ comments }: { comments: CommentType[] }) {
    return (
        <List
            itemLayout="vertical"
            dataSource={comments}
            renderItem={(comment: CommentType) => (
                <List.Item>
                    <CommentItem {...comment} />
                </List.Item>
            )}
        />
    );
}
